document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('lm-search-input');
  const searchForm = document.getElementById('lm-search-form');
  const resultsContainer = document.getElementById('lm-search-results');
  const productsGrid = document.getElementById('lm-search-products');
  const emptyState = document.getElementById('lm-search-empty');
  const loadingState = document.getElementById('lm-search-loading');

  let debounceTimer;
  const DEBOUNCE_DELAY = 300;

  // Debounce function
  function debounce(func, delay) {
    return function (...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Perform live search
  async function performSearch(query) {
    if (!query || query.trim().length < 2) {
      hideResults();
      return;
    }

    showLoading();

    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=12`,
      );
      const data = await response.json();

      console.log('Search API response:', data);
      console.log('Products found:', data.resources?.results?.products);

      hideLoading();

      // Handle different possible response structures
      const products = data.resources?.results?.products || [];
      displayResults(products);
    } catch (error) {
      console.error('Search error:', error);
      hideLoading();
      showEmpty();
    }
  }

  // Display search results
  function displayResults(products) {
    productsGrid.innerHTML = '';

    if (products.length === 0) {
      showEmpty();
      return;
    }

    resultsContainer.style.display = 'block';
    emptyState.style.display = 'none';

    products.forEach((product) => {
      const productCard = createProductCard(product);
      productsGrid.appendChild(productCard);
    });
  }

  // Create product card element
  function createProductCard(product) {
    const link = document.createElement('a');
    // Handle URL - might be string or object with 'url' property
    link.href =
      typeof product.url === 'string'
        ? product.url
        : product.url?.url || '/products/' + product.handle;
    link.className = 'lm-product-link';

    const card = document.createElement('div');
    card.className = 'lm-product-card';

    const imageWrapper = document.createElement('div');
    imageWrapper.className = 'lm-product__image-wrapper';

    const image = document.createElement('img');
    // Handle image - featured_image is an object with 'url' property, image is a string
    let imageUrl = '';
    if (product.featured_image && typeof product.featured_image === 'object') {
      imageUrl = product.featured_image.url || '';
    } else if (product.image) {
      imageUrl = product.image;
    }
    image.src = imageUrl;
    image.alt = product.title || '';
    image.className = 'lm-product__image';
    image.loading = 'lazy';

    imageWrapper.appendChild(image);

    const info = document.createElement('div');
    info.className = 'lm-product__info';

    const name = document.createElement('div');
    name.className = 'lm-product__name';
    name.textContent = product.title || '';

    const price = document.createElement('div');
    price.className = 'lm-product__price';
    // Handle price - might be in different formats
    const priceValue = product.price || product.price_min || 0;
    price.textContent = formatMoney(priceValue);

    info.appendChild(name);
    info.appendChild(price);

    card.appendChild(imageWrapper);
    card.appendChild(info);
    link.appendChild(card);

    return link;
  }

  // Format price
  function formatMoney(cents) {
    // Handle if price comes as string or number
    const price = typeof cents === 'string' ? parseFloat(cents) : cents;
    const amount = (price / 100).toFixed(2);
    return `R ${amount}`;
  }

  // Show loading state
  function showLoading() {
    loadingState.style.display = 'block';
    resultsContainer.style.display = 'none';
  }

  // Hide loading state
  function hideLoading() {
    loadingState.style.display = 'none';
  }

  // Show empty state
  function showEmpty() {
    resultsContainer.style.display = 'block';
    emptyState.style.display = 'block';
    productsGrid.innerHTML = '';
  }

  // Hide results
  function hideResults() {
    resultsContainer.style.display = 'none';
    emptyState.style.display = 'none';
    productsGrid.innerHTML = '';
  }

  // Event listeners
  searchInput.addEventListener(
    'input',
    debounce(function (e) {
      performSearch(e.target.value);
    }, DEBOUNCE_DELAY),
  );

  // Prevent form submission, but allow Enter key to work
  searchForm.addEventListener('submit', function (e) {
    e.preventDefault();
    const query = searchInput.value.trim();
    if (query) {
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    }
  });

  // Clear results when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.lm-search-container')) {
      hideResults();
    }
  });
});
